import { archiveNotes } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function NotesSection() {
  return (
    <section id="notes" className="w-full bg-background-50">
      <div className="w-full px-4 py-10 md:px-6 md:py-14">
        <div className="mx-auto w-full max-w-[1220px]">
          <SectionHeading
            index="05"
            label="归档说明"
            title="我们怎样判断一条出处的可信度"
            desc="本站只对已经公开传播的内容做来源梳理与时间线归档，所有结论以公开信息为准。"
          />

          <div className="mt-6 grid grid-cols-1 gap-4 md:grid-cols-3">
            {archiveNotes.map((note, index) => (
              <div key={note.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
                <span
                  className={`flex h-9 w-9 items-center justify-center rounded-md font-heading text-sm font-bold ${
                    index === 1 ? "bg-accent-500 text-foreground-950" : "bg-primary-100 text-primary-700"
                  }`}
                >
                  0{index + 1}
                </span>
                <h4 className="mt-3 font-heading text-base font-bold text-foreground-950">{note.title}</h4>
                <p className="mt-2 text-xs leading-relaxed text-foreground-600 md:text-sm">{note.desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-4 flex flex-col gap-2 rounded-lg border border-secondary-200 bg-secondary-100 p-4 md:flex-row md:items-center md:justify-between">
            <p className="text-xs leading-relaxed text-secondary-900">
              若你是相关内容的当事人，认为出处梳理存在偏差，可通过讨论区提交更正说明，我们会重新比对时间线。
            </p>
            <a
              href="#discussion"
              className="inline-flex shrink-0 items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-secondary-600 px-4 py-2 text-xs font-medium text-background-50 transition-colors hover:bg-secondary-700"
            >
              <i className="ri-edit-2-line"></i>
              提交更正说明
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}